import React from 'react';
import { Form, InputNumber } from 'antd';
import './CustomerNumberInput.scss';

function CustomerNumberInput({
  label,
  name,
  icon,
  className,
  errorMessage,
  preserve = false,
  rules = [],
}) {
  return (
    <Form.Item className={`customer-number-input ${className}`} rules={rules} name={name} label={label} help={errorMessage} validateStatus={errorMessage && 'error'} preserve={preserve}>
      {icon
        ? (
          <div className="relative">
            <InputNumber controls={false} />
            <div className="absolute text-gray-ch right-3 top-[50%] translate-y-[-50%]">{icon}</div>
          </div>
        )
        : (
          <InputNumber controls={false} />
        )}
    </Form.Item>
  );
}

export default CustomerNumberInput;
